module.exports = __webpack_public_path__ + "static/media/twitter.3e993ec3.svg";